module.exports = __webpack_public_path__ + "media/src/images/testimonials/02-ea665d9797dcc5fff5e377ac5792511a.jpg";